<template>
        <div v-if="hasInstructions" class="instructions-card p-4 ms-3">
            <!-- <h5>Instructions</h5> -->

            <div ref="instructionContainer"
                v-html="savedFormData.data.entity_details[0].custom_text"
                :class="['instruction-content', { collapsed: !showFullInstructions }]"
            ></div>

            <div v-if="!showFullInstructions" class="fade-overlay"></div>

                <p @click="toggleInstructions" class="text-danger fw-bold mb-0 mt-2" style="cursor: pointer;">
                    {{ showFullInstructions ? 'Show Less' : 'Read More...' }}
                </p>
            </div>

</template>
<script>
export default {
  props: ['currentStep'],
  data() {
    return {
      savedFormData: null,
      showFullInstructions: true
    };
  },
  computed: {
    hasInstructions() {
      const customText = this.savedFormData?.data?.entity_details?.[0]?.custom_text;
      return customText && customText.trim() !== '';
    }
  },
  methods: {
    toggleInstructions() {
      this.showFullInstructions = !this.showFullInstructions;
    }
  },
  mounted() {
    const saved = localStorage.getItem('form_response');
    this.savedFormData = saved ? JSON.parse(saved) : null;
  }
};
</script>
<style>
.instruction-content.collapsed {
  max-height: 180px;
  overflow: hidden;
  position: relative;
}

.fade-overlay {
  margin-top: -2.5rem;
  height: 60px;
  background: linear-gradient(to bottom, transparent, white);
  pointer-events: none;
  position: relative;
  z-index: 1;
}



.instruction-content {
  font-size: 0.9rem;
  line-height: 1.6;
  /* color: #fff !important; */
  padding-right: 0.25rem;

  /* prevent overflow */
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word; /* fallback */
  white-space: normal;
}


.fade-overlay {
  position: absolute;
  bottom: 2.5rem;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to bottom, transparent, #fff);
  pointer-events: none;
  border-radius: 0 0 12px 12px;
}

.toggle-btn {
  cursor: pointer;
  display: inline-block;
}
</style>
<style scoped>
.instructions-card {
  display: block !important;
  width: 100%;
  box-sizing: border-box;
  padding: 1.25rem;
  border-radius: 12px;
  margin-top: 1.5rem;
  position: relative;
  max-height: 400vh !important;
  overflow-y: auto !important; /* scroll vertically if content exceeds height */
  overflow-x: hidden;
}


/* Ensure it behaves well on small screens */
@media (max-width: 767px) {
  .instructions-card {
    max-height: 350vh !important;        /* slightly shorter for mobile */
    overflow-y: scroll !important; /* enforce scrolling */
    margin-bottom: 1rem;
    padding: 1rem;
  }
}
/* Ensure it behaves well on tablet and mobile screens */
@media (max-width: 1366px) {
  .instructions-card {
    max-height: 150vh !important;              /* good height for tablets */
    overflow-y: auto !important;   /* allow scrolling if content is tall */
    margin-bottom: 1rem;
    padding: 1rem;
  }
}
</style>